<div class="main-content" id="main-content">
   <section id="breadcrumbs">
      <div class="container-lg">
         <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
               <div class="br-breadcrumb">
                  <ul class="crumb-list">
                     <li class="crumb home">
                        <a class="br-button circle" [routerLink]="['/']"
                           ><span class="sr-only">Página inicial</span
                           ><i class="fas fa-home"></i
                        ></a>
                     </li>
                     <li class="crumb" data-active="active">
                        <i class="icon fas fa-chevron-right"></i
                        ><span>Expediente</span>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </section>
   <section id="page" aria-label="expediente" id="expediente">
      <div class="container-lg">
         <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
               <div id="page-header">
                  <div id="page-title" class="row">
                     <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <h2>Expediente</h2>
                     </div>
                  </div>
                  <div id="page-content">
                     <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                           <div
                              id="expediente-container"
                              tabindex="0"
                              [innerHTML]="
                                 sobre | formatExpediente | higienizaHTML
                              "
                              #expediente
                           ></div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
</div>
